
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface SearchFilters {
  query?: string;
  disciplineId?: string;
  status?: string;
  nodeType?: string;
  tags?: string[];
  limit?: number;
  offset?: number;
}

export const useEnhancedSearch = (filters: SearchFilters) => {
  return useQuery({
    queryKey: ['enhanced-search', filters],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('search_nodes', {
        search_query: filters.query || '',
        discipline_filter: filters.disciplineId || null,
        status_filter: filters.status || null,
        node_type_filter: filters.nodeType || null,
        tag_filter: filters.tags || null,
        limit_count: filters.limit || 20,
        offset_count: filters.offset || 0,
      });

      if (error) throw error;
      return data || [];
    },
    enabled: !!(filters.query || filters.disciplineId || filters.status || filters.nodeType || filters.tags?.length),
  });
};

export const useSearchSuggestions = (query: string) => {
  return useQuery({
    queryKey: ['search-suggestions', query],
    queryFn: async () => {
      if (!query || query.length < 2) return [];

      const { data, error } = await supabase.rpc('get_search_suggestions', {
        search_query: query,
        limit_count: 8,
      });

      if (error) throw error;
      return data || [];
    },
    enabled: query.length >= 2,
    staleTime: 30 * 1000, // 30 seconds
  });
};
